<template>
  <section>
    <div class="mb-6 flex flex-col gap-4 lg:flex-row lg:items-end lg:justify-between">
      <div>
        <div class="eyebrow">Obrigações e pagamentos</div>
        <h1 class="mt-2 text-3xl font-extrabold text-[#102a5a]">Programações de pagamento</h1>
        <p class="mt-1 text-sm text-slate-500">Organize parcelas, data planejada e aprovação antes de registrar o pagamento.</p>
      </div>
      <router-link v-if="canWrite" class="btn-primary" to="/programacoes-pagamento/nova"><AppIcon name="plus" class="h-4 w-4" />Nova programação</router-link>
    </div>

    <section class="card mb-5 p-5">
      <form class="obligation-filter-grid" @submit.prevent="apply">
        <label class="obligation-search-field"><span class="label">Busca</span><input v-model.trim="filters.search" class="input" placeholder="ID, participante ou referência"></label>
        <label><span class="label">Situação</span><select v-model.number="filters.statusId" class="input"><option :value="0">Todas</option><option v-for="x in options.statuses" :key="x.id" :value="x.id">{{ x.name }}</option></select></label>
        <label><span class="label">Aprovação</span><select v-model="filters.requiresApproval" class="input"><option value="">Todas</option><option value="true">Obrigatória</option><option value="false">Dispensada</option></select></label>
        <div class="obligation-filter-actions"><button class="btn-primary" type="submit">Filtrar</button></div>
      </form>
    </section>

    <section class="card overflow-hidden">
      <GridListHeader title="Programações" :total="total" singular-label="programação" plural-label="programações" feminine :loading="loading" />
      <div v-if="loading" class="document-loading"><span class="loading-spinner" />Carregando...</div>
      <div v-else class="document-table-scroll">
        <table class="document-entry-table">
          <thead><tr><th>ID</th><th>Data programada</th><th>Pagadora</th><th>Recebedora</th><th class="numeric-cell">Total</th><th class="numeric-cell">Executado</th><th>Aprovação</th><th>Situação</th><th>Ações</th></tr></thead>
          <tbody>
            <tr v-if="!items.length"><td colspan="9" class="empty-state">Nenhuma programação encontrada.</td></tr>
            <tr v-for="x in items" :key="x.id"><td>#{{ x.id }}</td><td>{{ date(x.scheduledAt) }}</td><td>{{ x.payerName }}</td><td>{{ x.receiverName }}</td><td class="numeric-cell">{{ money(x.totalAmount) }}</td><td class="numeric-cell">{{ money(x.executedAmount) }}</td><td>{{ x.requiresApproval ? 'Sim' : 'Não' }}</td><td><span class="obligation-status" :class="status(x.statusCode)">{{ x.statusName }}</span></td><td><router-link class="row-action view" :to="`/programacoes-pagamento/${x.id}`"><AppIcon name="eye" /></router-link></td></tr>
          </tbody>
        </table>
      </div>
      <GridPagination :page="page" :page-size="pageSize" :total="total" :loading="loading" @change-page="go" @change-page-size="changePageSize" />
    </section>
  </section>
</template>

<script>
import Swal from 'sweetalert2'
import AppIcon from '../components/AppIcon.vue'
import GridListHeader from '../components/GridListHeader.vue'
import GridPagination from '../components/GridPagination.vue'
import service from '../services/paymentOrderService'
import access from '../services/financialAccessService'

export default {
  name: 'PaymentOrdersView',
  components: { AppIcon, GridListHeader, GridPagination },
  data: () => ({ items: [], options: { statuses: [] }, filters: { search: '', statusId: 0, requiresApproval: '' }, page: 1, pageSize: 20, total: 0, loading: false, canWrite: false }),
  computed: { totalPages () { return Math.ceil(this.total / this.pageSize) } },
  async created () {
    try {
      [this.options, this.canWrite] = await Promise.all([service.getOptions(), access.has('PAYMENT_ORDERS', 2)])
      await this.load()
    } catch (error) { this.error(error) }
  },
  methods: {
    async load () {
      this.loading = true
      try {
        const result = await service.getPaged({ page: this.page, pageSize: this.pageSize, search: this.filters.search || undefined, statusId: this.filters.statusId || undefined, requiresApproval: this.filters.requiresApproval || undefined })
        this.items = result.items
        this.total = result.totalCount
      } catch (error) { this.error(error) } finally { this.loading = false }
    },
    apply () { this.page = 1; this.load() },
    go (page) { if (page < 1 || page > this.totalPages) return; this.page = page; this.load() },
    changePageSize (pageSize) { this.pageSize = pageSize; this.page = 1; this.load() },
    date (value) { return value ? new Intl.DateTimeFormat('pt-BR', { dateStyle: 'short', timeStyle: 'short' }).format(new Date(value)).replace(',', '') : '—' },
    money (value) { return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value || 0) },
    status (code) { return `status-${String(code).toLowerCase().replaceAll('_', '-')}` },
    error (error) { Swal.fire('Atenção', error?.response?.data?.title || 'Não foi possível carregar as programações.', 'error') }
  }
}
</script>
